import { emPagination, emLoadMore } from '../pagination';
import { getParams, setParams } from './params.js';
import { setActiveFilters } from './active-filters.js';
import { emFetchPosts, scrollToEl } from '../helpers.js';

/**
 * Pass parameters and fetch from post factory api.
 * @param  {Object}   element  the element to append/replace the html.
 * @param  {Object}   params   the query parameters to pass to the rest api.
 * @param  {Function} template the html markup.
 */
const getFilterableContent = (element, params = {}) => {
	(async () => {
		const hasUrlParams = window.location.search;
		if (hasUrlParams) {
			params.term_counts = true;
		} else {
			// Need this for popstate when no url params.
			params.paged = 1;
		}
		// Get the posts
		const data = await emFetchPosts(params);

		// console.log('Filterable Content Response:', data);

		if (data.posts) {
			// Get data.
			const {
				blockId,
				posts,
				notFoundMessage,
				foundPosts,
				currentPage,
				pagination,
				terms,
			} = data;

			// Get current block.
			const block = document.getElementById(blockId);

			let html = '';

			// Pass the post data to the template.
			posts.forEach((post) => {
				html += `<div class="em-col">${post}</div>`;
			});

			// Output the pagination.
			if (pagination === 'load_more') {
				html += emLoadMore(data.maxNumPages, currentPage);
			} else {
				html += emPagination(data.maxNumPages, currentPage, 8, 'em-col-12 pagination');
			}

			// Append or replace the markup.
			if (pagination === 'load_more' && currentPage !== 1) {
				element.innerHTML += html;
			} else {
				element.innerHTML = html;
			}

			// No Posts Found
			if (posts.length === 0) {
				element.innerHTML = notFoundMessage;
			}

			// Process the pagination actions.
			const pageNumbers = block.querySelectorAll('.page-numbers, .load-more');
			const filterContainer = block.querySelector('.em-filterable-content__filter-container');
			const contentContainer = block.querySelector('.em-filterable-content__listings');
			const inputs = block.querySelectorAll('input');

			// Loop through page numbers.
			pageNumbers.forEach((page) => {
				page.addEventListener('click', (e) => {
					page = e.target.closest('.page-numbers');
					filterContainer.dataset.paged = page.dataset.page;
					scrollToEl(element.parentElement, 0);

					setParams(block);
					// Fetch the content.
					getFilterableContent(contentContainer, getParams(block));
				});
			});

			// Set Count.
			const resultCount = block.querySelector('.em-filterable-content__count .count');
			resultCount.innerHTML = foundPosts;

			// Set active filter "pills".
			setActiveFilters(block, inputs, getFilterableContent);

			const updateTermCounts = (terms) => {
				inputs.forEach((input) => {
					const termId = input.getAttribute('data-term-id');
					if (termId) {
						const count = input.nextElementSibling.querySelector('.count');
						const disable = () => {
							input.setAttribute('disabled', 'disabled');
							count.innerHTML = '(0)';
						};

						if (!terms) {
							input.removeAttribute('disabled');
							count.innerHTML = `(${input.dataset.count})`;
						} else if (termId in terms) {
							if (terms[termId] === 0) {
								disable();
							} else {
								input.removeAttribute('disabled');
								count.innerHTML = `(${terms[termId]})`;
							}
						} else {
							disable();
						}
					}
				});
			};

			//  Update term counts.
			updateTermCounts(terms);

			if (pagination === 'load_more') {
				const links = block.querySelectorAll('a');
				links.forEach((link) => {
					link.setAttribute('target', '_blank');
					link.setAttribute('rel', 'noopener norefferer');
				});
			}
		}
	})();
};

export default getFilterableContent;
